export const common = {
    [process.env.PRJ_ENV.toLowerCase()]: true,
    API_HOST: '',
    FB_APP_ID: '141835276434157',
    RECAPTCHA_KEY: '6LcZ6LgUAAAAABs8F5-fBUQE26dIpRHhJPykEIwV',
    VU_HOST: 'https://vu.ruptly.tv/',
    MEDIA_CENTRE: 'https://mediacentre.ruptly.tv'
};
